import { useEffect } from "react";
import Navigation from "@/components/Navigation";
import HeroAlt from "@/components/HeroAlt";
import XFactorAlt from "@/components/XFactorAlt";
import Ecosystem from "@/components/Ecosystem";
import HowItWorksAlt from "@/components/HowItWorksAlt";
import FounderAlt from "@/components/FounderAlt";
import NewsSection from "@/components/NewsSection";
import FooterAlt from "@/components/FooterAlt";
import StructuredData from "@/components/StructuredData";
const Index = () => {
  useEffect(() => {
    let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", window.location.href);
  }, []);

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "AMX Ventures",
    "alternateName": "AMX",
    "url": "https://amxventures.com",
    "logo": "https://amxventures.com/amx-logo-light.svg",
    "description": "Venture capital firm investing in B2B SaaS companies. Capital that comes with channels - ecosystem-led growth through hyperscaler partnerships.",
    "founder": {
      "@type": "Person",
      "name": "Arun Mohan",
      "jobTitle": "Managing Partner",
      "description": "Experienced entrepreneur with 15+ years building ventures, 2 exits, and proven track record in ecosystem-led GTM."
    },
    "sameAs": [
      "https://www.linkedin.com/company/amxventures"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "Investment Inquiries",
      "url": "https://amxventures.com/schedule"
    }
  };

  const investmentFirmSchema = {
    "@context": "https://schema.org",
    "@type": "FinancialService",
    "name": "AMX Ventures",
    "description": "Venture capital firm specializing in B2B SaaS and enterprise software investments with ecosystem-led growth strategy.",
    "serviceType": "Venture Capital",
    "areaServed": "Global",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Investment Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Seed Stage Investment",
            "description": "Early-stage funding with ecosystem partnership guidance"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Growth Stage Investment",
            "description": "Scaling capital with hyperscaler GTM acceleration"
          }
        }
      ]
    }
  };

  return (
    <div className="min-h-screen">
      <StructuredData data={organizationSchema} />
      <StructuredData data={investmentFirmSchema} />
      <Navigation />
      <main>
        <HeroAlt />
        <NewsSection />
        <Ecosystem />
        <XFactorAlt />
        <HowItWorksAlt />
        <FounderAlt />
      </main>
      <FooterAlt />
    </div>
  );
};

export default Index;
